import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'
import type { Router } from 'vue-router'

export let router: Router

export const getRouter = (): Router => {
  router = createRouter({
    history: createWebHistory(),
    routes,
  })

  return router
}
